import React from "react"
import {Button} from 'primereact/button';
import {Dialog} from "primereact/dialog";
import {FormSections, FormSubSections, LOVValues} from "../../entities/formTemplateDataType";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {textBoxLengths, TextType, textTypeOption} from "../../entities/Constants";
import {Checkbox} from "primereact/checkbox";
import {InputTextarea} from "primereact/inputtextarea";
import {DialogBase, Props} from "./DialogBase";

interface State {
    pickedFieldOptions;
}
export class DialogForTextComponent extends DialogBase<Props,State> {

    dateTypeFieldList = [];
    subSection: FormSubSections;

    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        };
        this.subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = this.subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
        this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: this.props.ele.input?.submitCollect ?? true};
    }

    componentDidMount(): void {
        if(this.props.ele.FilterField!=null){
            this.onChangeHanlder(this.props.ele.FilterField)
        }
    }


    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let currentSection = this.subSection.parent as FormSections;
        let totalOption = [];
        const sections = currentSection.parent.ListOfFormSections;
    
        sections.filter(p => p.Sequence <= currentSection.Sequence).forEach((section) => {
            section.ListOfFormSubSections.forEach((sub) => {
                let eleListPrior = sub.ListOfFormSectionElements.filter(
                    p => p.Sequence < this.props.ele.Sequence || sub.Sequence < this.subSection.Sequence
                );
    
                // Handle Row datatype with dropdown sub-elements
                eleListPrior.forEach(element => {
                    if (element.Datatype === "Row" && element.subSectionList && element.subSectionList.length > 0) {
                        element.subSectionList.forEach(subSection => {
                            subSection.ListOfFormSectionElements.forEach(subElement => {
                                if (["RadioButton", "CheckGroup", "Dropdown"].includes(subElement.Datatype)) {
                                    eleListPrior.push(subElement);
                                }
                            });
                        });
                    }
                });
                let pickedFieldOptions = eleListPrior.filter(
                    (ele) => ele.LoadBindName?.replace(/\s/g, "") == newValue
                ).map((q) => {
                    const container = {};
                    if (q.Datatype == "Checkbox") {
                        const yLOVValue = new LOVValues();
                        yLOVValue.code = "Y";
                        yLOVValue.description = "Y";
                        const nLOVValue = new LOVValues();
                        nLOVValue.code = "N";
                        nLOVValue.description = "N";
                        container[q.LoadBindName] = [yLOVValue, nLOVValue];
                    } else {
                        container[q.LoadBindName] = q.ListOfLOVValues;
                    }
                    return container;
                });
                totalOption.push(...pickedFieldOptions);
            });
        });
       
        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    otherPreviousDateFields = () => {
        let elementListWithOptions = [{code:'', description:'Please select a field'}];
  
        let allElements=[];

        let section = this.subSection.parent as FormSections;
        
        //get the section list prior to this one
       if(this.props.ele.parent.parent?.Datatype!=="Row"){
        section.ListOfFormSubSections.forEach(sub=>{
             let elementList =sub.ListOfFormSectionElements.filter(p=>p.Sequence<this.props.ele.Sequence && sub.Sequence==this.subSection.Sequence || sub.Sequence<this.subSection.Sequence);
             allElements.push(...elementList);

             // Handle Row datatype with sub-elements
             elementList.forEach(element => {
                if (element.Datatype === "Row" && element.subSectionList && element.subSectionList.length > 0) {
                    element.subSectionList.forEach(subSection => {
                        subSection.ListOfFormSectionElements.forEach(subElement => {
                            if (["RadioButton", "CheckGroup", "Dropdown"].includes(subElement.Datatype)) {
                                allElements.push(subElement);
                            }
                        });
                    });
                }
            });
        });


        let list = allElements.filter(
            (q) =>
            (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown" ||
                q.Datatype === "Checkbox")
        ).map((q) => {
            return {
                code: q.LoadBindName?.replace(/\s/g, ""),
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });
        // elementListWithOptions.push('')
        elementListWithOptions.push(...list);
        
       }
    

        let htmlString = [];

        htmlString.push(
            <div>
                {this.scriptHtml()}
                {this.initScriptHtml()}
                {this.stepperScriptHtml()}
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Key Stroke Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input"
                            value={this.props.ele.KeyStrokeScript} onChange={(e) => {
                                this.props.ele.KeyStrokeScript = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
               <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Field Length</div>
                    <div style={{ width: '25%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={textBoxLengths} optionLabel='label' optionValue='val' value={this.props.ele.Length} onChange={(e) => {
                           this.props.ele.Length = e.target.value;
                           this.props.callback();
                        }}></Dropdown>
                    </div>
                    <div style={{ width: '10%' }}>Length in Pixel:</div>
                    <div style={{ width: '25%' }}>
                        {/* @ts-ignore */}
                     <InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Gap in px' title="gap between controls in the same row" 
                                                 value={this.props.ele.LengthInPixel}
                                                 onChange={(e) => {
                                                    this.props.ele.LengthInPixel = e.target.value;
                                                    this.props.callback();
                                                }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Auto format pattern:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input"
                                   value={this.props.ele.autoFormatPattern?.toString()}
                                   onChange={(e) => {
                                       this.props.ele.autoFormatPattern = e.target.value;
                                       this.props.callback();
                                   }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Max Length:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input"
                            value={this.props.ele.maxLength?.toString()}
                            onChange={(e) => {
                                    this.props.ele.maxLength = Number(e.target.value);
                                    this.props.callback();
                            }}
                        />
                    </div>
                </div>
                {this.props.ele.maxLength && <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"counter_visible_label_" + this.props.ele.Sequence}>Show Counter:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <Checkbox value={this.props.ele.showOptionalLabel ?? false} 
                            id={"counter_visible_label_" + this.props.ele.counterVisible}
                            onChange={(e) => { 
                                this.props.ele.counterVisible = e.checked; 
                                this.props.callback();
                            }} 
                            checked={this.props.ele.counterVisible ?? false}
                        />
                    </div>
                </div>}

                {this.regexHtml()}
                {this.emptyErrorMessageHtml()}
                {this.errorMessageHtml()}
                {this.questionHintHtml()}
                {this.tooTipHtml()}
                {this.hintExpansionTitleHtml()}
                {this.calloutBoxHtml()}
                {this.fieldSizeHtml()}
                {this.InitialVisibility()}
                <div style={{ display:  "flex",  marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown options={elementListWithOptions} style={{width:'100%'}}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField??''}
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);}
                            }></Dropdown></div>
                </div>
                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        <div>
                            {/* @ts-ignore */}
                            <Dropdown style={{width:'100%'}}
                                className="ontario-dropdown-small"
                                options={this.state.pickedFieldOptions[0] != null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                                value={this.props.ele.FilterValue}
                                optionLabel="description"
                                optionValue="code"
                                placeholder="Filtering value"
                                onChange={(e) => {
                                    this.props.ele.FilterValue = e.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Text type:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown options={textTypeOption} style={{width:'100%'}} id={"text_type_" + this.props.ele.Sequence}
                            className="ontario-dropdown-small"
                            optionLabel="label"
                            optionValue="val"
                            value={this.props.ele.TextType}
                            onChange={(e) => {
                                this.props.ele.TextType = e.target.value as TextType;
                                this.props.callback()
                            }}
                        />
                    </div>
                </div>
                
                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_type_" + this.props.ele.Sequence}>Informational Text:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputText className="ontario-input"
                            value={this.props.isEng?this.props.ele.informationalText: this.props.ele.informationalTextFRA}
                            onChange={(e) => {
                                if(this.props.isEng){
                                    this.props.ele.informationalText = e.target.value;
                                    this.props.callback()
                                }
                                else{
                                    this.props.ele.informationalTextFRA = e.target.value;
                                    this.props.callback()
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Show Optional/Required Label:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.showOptionalLabel ?? true} 
                            id={"show_optional_label_" + this.props.ele.Sequence}
                            onChange={(e) => { 
                                this.props.ele.showOptionalLabel = e.checked; 
                                this.props.callback() 
                            }} 
                            checked={this.props.ele.showOptionalLabel ?? true}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"text_inline_" + this.props.ele.Sequence}>Inline (Styling):</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.inlineStyling} 
                            id={"text_inline_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.inlineStyling = e.checked; this.props.callback() }} 
                            checked={this.props.ele.inlineStyling}
                        />
                    </div>
                </div>
                {this.maskSummaryHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"collect_submit" + this.props.ele.Sequence}>Collect for submit:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.input?.submitCollect} 
                            id={"collect_submit" + this.props.ele.Sequence}
                            onChange={(e) => { 
                                this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: e.checked}; 
                                this.props.callback() 
                            }} 
                            checked={this.props.ele.input?.submitCollect}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"triggerSubmit_" + this.props.ele.Sequence}>Enable Submit on Enter:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.input?.triggerSubmitOnEnter ?? false} id={"triggerSubmit_" + this.props.ele.Sequence}
                            checked={this.props.ele.input?.triggerSubmitOnEnter ?? false} 
                            onChange={(e) => { 
                                this.props.ele.input = {...this.props.ele.input ?? {}, triggerSubmitOnEnter: e.checked}; 
                                this.props.callback() 
                            }} 
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"triggerSubmit_" + this.props.ele.Sequence}>Allow digits only</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.input?.onlyNumbers ?? false} id={"onlyNumbers_" + this.props.ele.Sequence}
                            checked={this.props.ele.input?.onlyNumbers ?? false} 
                            onChange={(e) => { 
                                this.props.ele.input = {...this.props.ele.input ?? {}, onlyNumbers: e.checked}; 
                                this.props.callback() 
                            }} 
                        />
                    </div>
                </div>

                {this.excludeFromPayload()}
                {this.apiConfigsHtml()}
            </div>
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
